<template>
  <Teleport to='#modal'>
    <div
      class="modal d-block"
      id="HelpDeskModal"
      tabindex="1"
      role="dialog"
      ref="helpDeskModal"
      @keyup.esc="store.dispatch('toggleHelpDeskDialog')"
      :class="{ 'inga-modal-overlay-dark': store.state.isDarkMode }"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <div
          class="modal-content border-0"
          :class="{ 'inga-modal-panel-dark': store.state.isDarkMode }"
        >
          <div class="modal-header d-flex justify-content-between align-items-center border-bottom-0">
            <h4 class="font-weight-bolder mb-0">Kontaktní formulář</h4>
            <span
              class="inga-close-btn"
              :class="{ 'inga-close-btn-dark': store.state.isDarkMode }"
              role="button"
              tabindex="0"
              aria-label="Zavřít"
              @click="store.dispatch('toggleHelpDeskDialog')"
              @keydown.enter.prevent="store.dispatch('toggleHelpDeskDialog')"
              @keydown.space.prevent="store.dispatch('toggleHelpDeskDialog')"
            >&times;</span>
          </div>
          <div class="modal-body px-2">
            <div class="card card-plain">
              <div class="py-0 card-header text-start">
                <argon-alert 
                  v-for="msg in alert.message" :key="msg"
                  v-show="alert.type == 'danger'"
                  class="mb-0 text-sm text-center" 
                  :color="alert.type"
                >
                  {{ msg }}
                </argon-alert>
              </div>
              <div class="card-body">
                <form @submit.prevent="submitHelpDeskForm" onsubmit="return false">
                  <div class="mb-3">
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="helpdesk.name"
                      placeholder="Jméno"
                      name="HelpDeskName"
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <input
                      type="tel"
                      class="form-control form-control-lg"
                      v-model="helpdesk.phone"
                      placeholder="Telefon"
                      name="HelpDeskPhone"
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <input
                      type="email"
                      class="form-control form-control-lg"
                      v-model="helpdesk.email"
                      placeholder="E-mail"
                      name="email"
                      autocomplete="off"
                      required
                    />
                  </div>
                  <div class="mb-3">
                    <textarea
                      v-model="helpdesk.message"
                      class="form-control"
                      id="helpdesk-textarea"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                  <div class="text-center">
                    <argon-button
                      class="mt-4"
                      color="primary"
                      size="lg"
                      :disabled="isButtonLoading"
                      fullWidth>
                      <span v-if="isButtonLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Odeslat
                    </argon-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, reactive, computed, inject, onMounted } from "vue";
import { useStore } from "vuex";
import dataService from "@/services/dataService";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

const store = useStore();
const cookies = inject('$cookies');
const swal= inject('$swal');
const helpDeskModal = ref(null)
const helpdesk = reactive({
  name: '',
  phone: '',
  email: '',
  message: '',
});

const alert = computed(() => store.state.alert);
const userID = computed(() => store.getters.getUser.UserID);
const isLoggedIn = computed(() => store.getters.isLoggedIn);
const isButtonLoading = computed(() => store.getters['loadingModule/isButtonLoading']);

onMounted(() => {
  helpDeskModal.value.focus();
})

const submitHelpDeskForm = async () => {
  try {
    store.dispatch('loadingModule/setButtonLoading', true);
    const cookieUserID = cookies.get('userID');
  
    let response;
    // send form data
    if (isLoggedIn.value) {
      response = await dataService.HelpDesk(helpdesk, userID.value);
    } else if (cookieUserID) {
      response = await dataService.HelpDesk(helpdesk, '' , cookieUserID);
    } else { 
      response = await dataService.HelpDesk(helpdesk);
    }

    if (response.Result) {
      store.dispatch('toggleHelpDeskDialog');
      swal.fire({
        position: 'center',
        icon: 'success',
        html: `<h5>${response.InfoMessage[0]}</h5>` + `<p>${response.InfoMessage[1]}</p>`,
        showConfirmButton: false,
        timer: 3000,
      })
    } else { 
      store.dispatch('alertError', response.ErrorMessage);
    }
  } catch (error) {
    console.error(error);
  } finally {
    store.dispatch('loadingModule/setButtonLoading', false);
  }
};

</script>
